export const publicRoutes: string[] = [
  '/login',
];
